import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { getCredential } from '../../utils/auth'
import { Button, Icon, Input } from 'antd'
import { signInWithGoogle, signIn } from '../../modules/auth'

import './index.css'

class GoogleLogin extends Component {

  state = {
    username: null,
    password: null
  }

  async signInWithGoogle() {
    const credential = await getCredential()
    this.props.signInWithGoogle(credential)
  }

  render() {
    return (
      <div className="login-container">
        <div className="login-card">
          <div>
            <h1 className="login-title">TMS</h1>
            <h4 className="login-label">Transport Management System</h4>
            <Input
              value={this.state.username}
              onChange={(event => {
                this.setState({ username: event.target.value })
              })}
              size={'large'}
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={'Usuario'}
              style={{ marginBottom: 15 }}
            />
            <Input
              value={this.state.password}
              onChange={(event => {
                this.setState({ password: event.target.value })
              })}
              size={'large'}
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={'Contraseña'}
              type="password"
              style={{ marginBottom: 15 }}
            />
            <Button
              className="login-button"
              block
              size={'large'}
              loading={this.props.loading}
              onClick={() => { this.props.signIn(this.state.username, this.state.password) }}
              type="primary"
            >
              Iniciar sesión
            </Button>
            <Button
              block
              size={'large'}
              loading={this.props.loading}
              onClick={() => { this.signInWithGoogle() }}
              type="primary"
            >
              <Icon type="google" />Iniciar sesion con Google
          </Button>
          </div>
        </div>
        <div className="login-footer">
          <span className="login-footer-label">Made with <span role="img" aria-label="heart-emoji">❤️</span> by INN</span>
        </div>
      </div>
    )
  }

}

const mapStateToProps = state => ({
  loading: state.auth.loading,
  unauthorized: state.auth.unauthorized
})

const mapDispatchToProps = dispatch => bindActionCreators({
  signInWithGoogle,
  signIn,
}, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GoogleLogin)
)



// WEBPACK FOOTER //
// ./src/containers/GoogleLogin/index.js